import React from 'react';
import { McButton } from '@maersk-global/mds-react-wrapper/components-core/mc-button';

const ParseButton = ({ onClick, loading, loadingPhase, disabled }) => {
  const label = loading
    ? (loadingPhase === 'extracting' ? 'Extracting…' : loadingPhase === 'analyzing' ? 'Analyzing…' : 'Processing…')
    : 'Parse';

  return (
    <McButton
      label={label}
      appearance="primary"
      variant="filled"
      icon={loading ? undefined : 'play'}
      loading={loading}
      disabled={disabled}
      click={() => { if (!disabled) onClick?.(); }}
    />
  );
};

export default ParseButton;
